import type { FactoryImage } from '../factory-image';

/**
 * Canonical mock {@link FactoryImage} used by tests, MSW handlers and
 * the demo build.
 */
export const MOCK_FACTORY_IMAGE: FactoryImage = {
  id: 1,
  url: 'https://picsum.photos/seed/factory-1/900/600',
  position: 0,
};

/** Builds a {@link FactoryImage} from {@link MOCK_FACTORY_IMAGE}. */
export function createMockFactoryImage(
  overrides?: Partial<FactoryImage>
): FactoryImage {
  return { ...MOCK_FACTORY_IMAGE, ...overrides };
}

/**
 * Builds a list of mock {@link FactoryImage} entries with distinct
 * placeholder image URLs and sequential positions.
 */
export function createMockFactoryImageList(
  count = 3,
  overrideAt?: (index: number) => Partial<FactoryImage>
): FactoryImage[] {
  return Array.from({ length: count }, (_, i) =>
    createMockFactoryImage({
      id: i + 1,
      url: `https://picsum.photos/seed/factory-image-${i + 1}/900/600`,
      position: i,
      ...overrideAt?.(i),
    })
  );
}
